{
  "login": {
    "forgotPassword": {
      "back": "Annuler",
      "button": "Mot de passe oublié ?",
      "submit": "Réinitialiser",
      "success": "Un lien de réinitialisation de votre mot de passe Trace for good arrivera bientôt dans votre boîte mail.",
      "title": "Réinitialisation du mot de passe."
    },
    "labels": {
      "email": "Email",
      "password": "Mot de passe"
    },
    "magicLink": {
      "button": "Cliquez ici pour vous authentifier",
      "success": "Si l’adresse e-mail que vous avez saisie est valide, vous recevrez dans les prochaines minutes un lien de connexion à usage unique. Veuillez vérifier votre boîte de réception — ainsi que vos dossiers spam ou courrier indésirable — avant de demander un nouveau lien. Merci."
    },
    "placeholders": {
      "email": "support@traceforgood.com",
      "password": "Mot de passe",
      "token": "Entrez le code généré par votre application d'authentification"
    },
    "submit": "Connexion",
    "usernameSubmit": "Continuer"
  },
  "profile": {
    "2faModal": {
      "confirmation": "Activer la double authentification ?",
      "description": "L'authentification à deux facteurs rend obligatoire la saisie d'un code à usage unique en plus du mot de passe habituel. Ce code sera obtenu depuis l'application choisie d'authentification à deux facteurs."
    },
    "labels": {
      "confirm": "Confirmation",
      "email": "Email",
      "name": "Nom",
      "password": "Mot de passe"
    },
    "passwordHelp": "{{minLength}} caractères minimum, avec au moins 1 chiffre et 1 majuscule.",
    "passwordsDoNotMatch": "Les mots de passe renseignés ne correspondent pas.",
    "placeholders": {
      "confirm": "Confirmer le nouveau mot de passe",
      "name": "Nom",
      "password": "Nouveau mot de passe"
    },
    "submit": {
      "infos": "Enregistrer",
      "password": "Enregistrer"
    },
    "title": "Mon profil",
    "titles": {
      "info": "Mes informations",
      "password": "Connexion"
    },
    "tooltips": {
      "email": "Contacter support@traceforgood.com pour modifier l'adresse email de connexion."
    },
    "updateSuccess": "Profil mis à jour !"
  }
}
